import classNames from 'classnames';

import styles from './styles.module.css';

const PageSizer = ({ fullPage = false, children }) => {
	return (
		<div
			data-testid="pageSizer"
			className={classNames(styles.pageSizer, { [styles.pageSizerFull]: fullPage })}
		>
			{children}
		</div>
	);
};

export default PageSizer;
